import { isMobile } from '@/utils';
import ResizeHandler from '@/utils/resizeHandler';
let resizer;
export default {
    mounted(el, binding) {
        if (binding.value?.disable) {
            return;
        }
        resizer = new ResizeHandler(el, {
            geometric: binding.value?.geometric,
            barWidth: isMobile ? 10 : 5,
            transform: binding.value?.transform,
            callback: binding.value?.callback
        });
    },
    beforeUnmount() {
        if (resizer) {
            resizer.off();
        }
    }
};
